import CityServicePage from "@/pages/city-service/CityServicePage";
import { torontoFurnaceRepair } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={torontoFurnaceRepair} />; }
